import { useLocation, useNavigate, Link } from "react-router-dom";
import { IoArrowBackSharp } from "react-icons/io5";
import { Breadcrumb, Button, Col, Row } from "antd";
import { IoIosArrowForward } from "react-icons/io";
import { FaPlus } from "react-icons/fa";
import "../pageHeader/style.css";

function PageHeader(props: any) {
  const navigate = useNavigate();
  const location = useLocation();

  // Titles for paths and segments
  const pathTitles: Record<string, string> = {
    Admin: "Admin",
    Dashboard: "Dashboard",
    Designer: "Designer",
    Developer: "Developer",
    Accountant: "Accountant",
    Employee: "Employee",
    Freelancer: "Freelancer",
    Telecaller: "Telecaller",
    Receptionist: "Receptionist",
    Client: "Client",
    Project: "Project",
    VisitorsDetails: "Visitors Details",
    update: "Update",
    viewuser: "Employee Details",
    viewclient: "Client Details",
    projectview: "Project Details",
    task_view: "Task Details",
    TelecallerDetails: "Telecaller Details",
    Project_details: "Project Details",
    Receptionist_profile: "Profile",
    Visitors: "Visitors",
    Telecaller_Details: "Telecaller Details",
    Visitors_details: "Visitors Details",
    Project_Details: "Project Details",
    view_task_Details: "Task Details",
    Telecaller_Profile: "Profile",
  };

  // Get page title dynamically based on the current path
  const getActivePageTitle = () => {
    const pathParts = location.pathname.split("/").filter(Boolean);
    const resolvedTitles = pathParts
      .filter((part) => !isDynamicParam(part)) // Exclude dynamic parameters
      .map((part) => pathTitles[part] || part);
    return resolvedTitles.join(" > ");
  };

  // Check if the segment is a dynamic parameter (e.g., an ID)
  const isDynamicParam = (segment: string) => /^\d+$/.test(segment); // Match numbers only

  return (
    <div className="main-page-header">
      <div className="PageHeader-Box">
        <Row
          align="middle"
          gutter={16}
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Col style={{ display: "flex", alignItems: "center" }} md={12}>
            <div onClick={() => navigate(-1)} className="PageHeader-box2">
              <IoArrowBackSharp size={25} color="#000" cursor="pointer" />
              <hr className="vertical-line" />
            </div>
            <div className="px-3 pageHeader-breadcrumb">
              <div className="pageHeader-title">{getActivePageTitle()}</div>
              <Breadcrumb
                separator={
                  <span>
                    <IoIosArrowForward color="rgba(54, 54, 54, 0.8)" />
                  </span>
                }
              >
                <Breadcrumb.Item>
                  <Link to="/Admin/Dashboard">Home</Link>
                </Breadcrumb.Item>
                {location.pathname
                  .split("/")
                  .filter(Boolean)
                  .filter((part) => !isDynamicParam(part)) // Exclude dynamic parameters
                  .map((part, index, array) => {
                    const url = `/${array.slice(0, index + 1).join("/")}`;
                    return (
                      <Breadcrumb.Item key={url}>
                        <Link to={url}>{pathTitles[part] || part}</Link>
                      </Breadcrumb.Item>
                    );
                  })}
              </Breadcrumb>
            </div>
          </Col>
          <Col style={{ display: "flex", justifyContent: "flex-end" }} md={12}>
            {props?.buttonTxt && (
              <Button
                className="primary-Button"
                size="large"
                onClick={props?.onSubmit}
              >
                <FaPlus />
                <span>{props?.buttonTxt}</span>
              </Button>
            )}
            {props?.children && (
              <div className="pageHeader-children">{props?.children}</div>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default PageHeader;
